// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-core-pages-StartingPage-StartingPage-module__body {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: var(--space-s);
}

.src-core-pages-StartingPage-StartingPage-module__title {
  margin-bottom: var(--space-xs);
}

.src-core-pages-StartingPage-StartingPage-module__cardContainer {
  width: 15%;
}

.src-core-pages-StartingPage-StartingPage-module__cardContainer:hover {
  background-color: var(--color-typo-normal);
  cursor: pointer;
}

.src-core-pages-StartingPage-StartingPage-module__card {
  width: 100%;
  justify-content: space-between;
}`, "",{"version":3,"sources":["webpack://./src/core/pages/StartingPage/StartingPage.module.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,8BAAA;AACJ;;AAEA;EACI,UAAA;AACJ;;AAEA;EACI,0CAAA;EACA,eAAA;AACJ;;AAEA;EACI,WAAA;EACA,8BAAA;AACJ","sourcesContent":[".body {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    gap:var(--space-s)\n}\n\n.title {\n    margin-bottom: var(--space-xs);\n}\n\n.cardContainer {\n    width: 15%;\n}\n\n.cardContainer:hover {\n    background-color: var(--color-typo-normal);\n    cursor: pointer;\n}\n\n.card {\n    width: 100%;\n    justify-content: space-between;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": `src-core-pages-StartingPage-StartingPage-module__body`,
	"title": `src-core-pages-StartingPage-StartingPage-module__title`,
	"cardContainer": `src-core-pages-StartingPage-StartingPage-module__cardContainer`,
	"card": `src-core-pages-StartingPage-StartingPage-module__card`
};
export default ___CSS_LOADER_EXPORT___;
